import React from 'react';
import { Divider, HStack, Icon } from '@medely/ui-kit';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { EducationItemFragment } from '../graphql';
import { EducationModal } from '../educationModal/EducationModal.web';
import useDialog from '@mp/hooks/useDialog';
import { EducationItemInfo } from './EducationItemInfo';
import { EducationEditModal } from './EducationEditModal.web';

type EducationItemProps = {
  educationItem?: FragmentType<typeof EducationItemFragment>;
};

export const EducationItem = ({ educationItem: inputEducationItem }: EducationItemProps) => {
  const educationItem = parseFragmentData(EducationItemFragment, inputEducationItem);

  const educationEditModal = useDialog();
  const educationModal = useDialog();

  return (
    <>
      <HStack
        alignItems="center"
        justifyContent="space-between"
        py={2}
        pl={2}
        onClick={educationEditModal.openDialog}
      >
        <EducationItemInfo educationItem={inputEducationItem} />
        <Icon name="chevron-right" variant="custom" color="text.secondary" iconSize="16px" />
      </HStack>
      <Divider />
      <EducationEditModal
        open={educationEditModal.open}
        onClose={educationEditModal.closeDialog}
        itemId={educationItem?.id}
        openEditModal={educationModal.openDialog}
      />
      <EducationModal
        education={inputEducationItem}
        open={educationModal.open}
        onClose={educationModal.closeDialog}
      />
    </>
  );
};
